import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  getDiscountPrice,
  getFinalPriceVariation,
} from "../../helpers/product";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import CustomerModal from "./modals/modalCustomer";
import {
  adjustCartForCheckOut,
  removeAllFromCart,
} from "../../redux/actions/cartActions";
import { fetchSendCheckout, sleep } from "../../helpers/dbOperations";
import { useToasts } from "react-toast-notifications";
import { Section, Title, Article, Prop, list } from "./animationList";
import ReactLoading from "react-loading";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, Icon, TextField } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { itIT } from "@mui/x-date-pickers";
import it from "date-fns/locale/it";
import { DatePicker } from "@mui/x-date-pickers";
import Holidays from "date-holidays";
import { format } from "date-fns";
import useToken from "../../hook/useToken";
const Checkout = ({
  location,
  cartItemsAll,
  currency,
  userData,
  removeAllFromCart,
  refreshCheckout,
  setRefreshCheckout,
}) => {
  //console.log(sessionStorage.getItem("idCli"))
  const [cartItems, setCartItems] = useState(cartItemsAll);
  const [isCaricamento, setIsCaricamento] = useState(false);
  const { pathname } = window.location;
  const [disable, setDisable] = useState(true);
  const originalSede = JSON.parse(
    sessionStorage.getItem("sede") ? sessionStorage.getItem("sede") : "{}"
  );
  const [sede, setSede] = useState(
    JSON.parse(
      sessionStorage.getItem("sede") ? sessionStorage.getItem("sede") : "{}"
    )
  );
  const spedizioni = JSON.parse(sessionStorage.getItem("spedizione"));
  const pagamenti = JSON.parse(sessionStorage.getItem("pagamenti"));
  const idCli = sessionStorage.getItem("idCli");
  const idDetCliSed = sessionStorage.getItem("idDetCliSed");
  const ModConsegna1 = 0; //sessionStorage.getItem("ModConsegna1")
  const ModConsegna2 = 0; //sessionStorage.getItem("ModConsegna2)
  const TotSpeSpe1 = sessionStorage.getItem("totSpeTra1");
  const TotSpeInc1 = sessionStorage.getItem("totSpeInc1");
  const TotSpeSpe2 = sessionStorage.getItem("totSpeTra2");
  const TotSpeInc2 = sessionStorage.getItem("totSpeInc2");
  const TotSpeImb1 = sessionStorage.getItem("totSpeImb1");
  const TotSpeImb2 = sessionStorage.getItem("totSpeImb2");
  const cliente = JSON.parse(sessionStorage.getItem("cliente"));
  const localita = JSON.parse(sessionStorage.getItem("localita"));
  const [speTra, setSpeTra] = useState(
    parseFloat(TotSpeSpe1) + parseFloat(TotSpeSpe2)
  );
  let cartTotalPrice = 0;
  const personal = JSON.parse(
    sessionStorage.getItem("personalCli")
      ? sessionStorage.getItem("personalCli")
      : "{}"
  );
  var strings = require("../../translations/italian.json");
  const { addToast } = useToasts();
  const [spe, setSpe] = useState(0);
  const [showDialogSpedizioni2maggio, setShowDialogSpedizioni2maggio] =
    useState(false);
  const [
    showDialogSpedizioniControlloCAP,
    setShowDialogSpedizioniControlloCAP,
  ] = useState(false);
  const [showDialogProssimoRitiro, setShowDialogProssimoRitiro] =
    useState(false);

  const history = useHistory();
  const [addresses, setAddresses] = useState([]);
  const [address, setAddress] = useState("");
  const [dataRitiro, setDataRitiro] = useState(null);
  const [datesForDisable, setDatesForDisable] = useState([
    "03-13-2023",
    "03-14-2023",
  ]);
  const [datesForEnable, setDatesForEnable] = useState([
    "03-13-2023",
    "03-14-2023",
  ]);

  const hd = new Holidays("IT");
  const [proxRitiro, setProxRitiro] = useState(null);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const { show, setShow } = useState(false);
  const [dateCaricate, setDateCaricate] = useState(false);
  const [pagamento, setPagamento] = useState(
    pagamenti?.find((pagamento) => pagamento.pagCli == 1)?.IdPag
  );
  const itemsNoSco = JSON.parse(
    sessionStorage.getItem("itemsNoSco") != "undefined"
      ? sessionStorage.getItem("itemsNoSco")
      : "[]"
  );
  const condizioni = JSON.parse(
    sessionStorage.getItem("condizioni") != "undefined"
      ? sessionStorage.getItem("condizioni")
      : "[]"
  );
  var informazioni = global.informazioni;
  const [tot, setTot] = useState(0);
  const [totPortoFranco, setTotPortoFranco] = useState(0);
  function isDataPassata(dataDaControllare) {
    const oggi = new Date();
    return dataDaControllare < oggi;
  }
  useEffect(() => {
    var totale = 0;
    if (cartItems && cartItems.length > 0) {
      cartItems.forEach((single) => {
        var finalProductPrice = 0;
        if (!single?.variation || single.variation?.length == 0) {
          finalProductPrice = single.price?.toFixed(2);
        } else {
          const discountedPrice = getDiscountPrice(
            single.price,
            single.discount,
            single.pricesco
          );
          finalProductPrice = getFinalPriceVariation(
            single,
            single.selectedProductColor,
            single.selectedProductSize
          ).toFixed(2);
          const finalDiscountedPrice = (
            discountedPrice * currency.currencyRate
          ).toFixed(2);
        }

        totale += finalProductPrice * single.quantity;
      });
      setTot(totale);
      setTotPortoFranco(390.0 - totale);
    }
  }, [cartItems]);
  useEffect(() => {
    if (refreshCheckout) {
      setRefreshCheckout(false);
      history.push("/precheckout");
    }
  }, [refreshCheckout]);
  useEffect(() => {
    //calcolaDate()

    cartItemsAll.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    cartItemsAll.sort((a, b) => {
      if (a.name === b.name) {
        if (parseInt(a.ord1 + a.ord2) < parseInt(b.ord1 + b.ord2)) return -1;
        if (parseInt(a.ord1 + a.ord2) > parseInt(b.ord1 + b.ord2)) return 1;

        /*if(parseInt(a.ord2) < parseInt(b.ord2)) return -1
        if(parseInt(a.ord2) > parseInt(b.ord2)) return 1*/
      }
      return 0;
    });
    setCartItems(
      cartItemsAll.map((item) => {
        //return { ...item, sco1: personal.S1, sco2: personal.S2 }
        return { ...item };
      })
    );
    //console.log(cartItems)
    var colors = ["red", "yellow"]; // Define Your colors here, can be html name of color, hex, rgb or anything what You can use in CSS
    var colors1 = ["white", "black"];
    var active = 0;
    setInterval(function () {
      if (document.getElementById("avviso")) {
        document.getElementById("avviso").style.background = colors[active];
        document.getElementById("avviso").style.color = colors1[active];
        active++;
        if (active == colors.length) active = 0;
      }
    }, 300);
  }, []);
  const checkAddress = () => {
    fetch(
      "https://api.geoapify.com/v1/geocode/autocomplete?text=" +
        address +
        "&format=json&apiKey=7add2f8fc2a04eb4992d1c2de9ff0b18"
    )
      .then((res) => res.json())
      .then((result) => {
        setAddresses(result.results);
        //console.log(result)
      });
    setShow(true);
  };
  const inviaOrdine = async () => {
    var json = {};
    if (error) {
      setErrorMessage("Seleziona una data di ritiro valida");
      return;
    }
    json.username = userData.user.user.username;
    json.password = userData.user.user.password;
    json.Cliente = {};
    json.Cliente.IdCli = idCli;
    json.Cliente.IDDetCliSed = idDetCliSed ? parseInt(idDetCliSed) : 0;
    json.Cliente.IndSed = document.getElementById("ind").value;
    json.Cliente.Loc = sede.Loc;
    json.Cliente.Pro = sede.Pro;
    json.Cliente.CAP = sede.CAP;
    json.Cliente.NAZ = sede.NAZ;
    json.Cliente.IDLoc = sede.IdLoc ? sede.IdLoc : 0;
    json.Cliente.Des2 = document.getElementById("dessedcli").value;
    json.Cliente.Num = document.getElementById("num").value;
    json.Cliente.Mail = document.getElementById("mail").value;
    json.Cliente.ParIva = userData.user.user.ParIva;
    json.Carrello = cartItems;
    console.log(cartItems);
    json.Documento = {};
    var rec = document.getElementById("dataRitiro")
      ? document.getElementById("dataRitiro").getBoundingClientRect()
      : null;
    if (document.getElementById("modGreen")?.value == "") {
      alert("Selezionare un valore consentito dal menu a tendina");
      return;
    }
    if (
      document.getElementById("modYellow") ||
      document.getElementById("attendiInvio")
    ) {
      if (
        document.getElementById("modYellow").value == "" &&
        document.getElementById("attendiInvio").value != "0"
      ) {
        alert("Selezionare un valore consentito dal menu a tendina");
        return;
      }
      if (document.getElementById("attendiInvio").value == "") {
        alert("Selezionare un valore consentito dal menu a tendina");
        return;
      }
    }

    json.Documento.ModConsegna1 = parseInt(
      document.getElementById("modGreen") &&
        document.getElementById("modGreen").value != ""
        ? document.getElementById("modGreen").value
        : 0
    );
    json.Documento.ModConsegna2 = parseInt(
      document.getElementById("modYellow") &&
        document.getElementById("modYellow").value != ""
        ? document.getElementById("modYellow").value
        : 0
    );
    //json.Documento.SollecitaNonInArrivo = document.getElementById("sollecito") ? document.getElementById("sollecito").checked : false
    if (
      document.getElementById("dataRitiro") &&
      document.getElementById("dataRitiro").style.display == "block" &&
      !dataRitiro
    ) {
      setErrorMessage("Selezionare una data valida per il ritiro");

      window.scrollTo(0, rec.top + window.scrollY - 200);
      return;
    }
    if (
      parseInt(
        document.getElementById("modGreen") &&
          document.getElementById("modGreen").value != ""
          ? document.getElementById("modGreen").value
          : 0
      ) == 34
    ) {
      if (parseInt(document.getElementById("attendiInvio")?.value) == 1) {
        if (datesForDisable.includes(format(dataRitiro, "MM-dd-yyyy"))) {
          setErrorMessage("Selezionare una data valida per il ritiro");
          window.scrollTo(0, rec.top + window.scrollY - 200);
          return;
        } else {
          if (!dataRitiro) {
            setErrorMessage("Selezionare una data valida per il ritiro");
            window.scrollTo(0, rec.top + window.scrollY - 200);
            return;
          }
          if (isDataPassata(dataRitiro)) {
            setErrorMessage("Selezionare una data valida per il ritiro");
            window.scrollTo(0, rec.top + window.scrollY - 200);
            return;
          }
          json.Documento.DataRitiro = format(
            dataRitiro,
            "yyyy-MM-dd HH:mm:ss.SSS"
          );
        }
      } else {
        if (getTotYellow() + getTotPre() == 0) {
          if (!dataRitiro) {
            setErrorMessage("Selezionare una data valida per il ritiro");
            window.scrollTo(0, rec.top + window.scrollY - 200);
            return;
          }
          if (isDataPassata(dataRitiro)) {
            setErrorMessage("Selezionare una data valida per il ritiro");
            window.scrollTo(0, rec.top + window.scrollY - 200);
            return;
          }
          json.Documento.DataRitiro = format(
            dataRitiro,
            "yyyy-MM-dd HH:mm:ss.SSS"
          );
        }
        if (
          document.getElementById("dataRitiro") &&
          document.getElementById("dataRitiro").style.display == "block"
        ) {
          if (isDataPassata(dataRitiro)) {
            setErrorMessage("Selezionare una data valida per il ritiro");
            window.scrollTo(0, rec.top + window.scrollY - 200);
            return;
          }
          json.Documento.DataRitiro = format(
            dataRitiro,
            "yyyy-MM-dd HH:mm:ss.SSS"
          );
        }
      }
    }
    if (
      document.getElementById("dataRitiro") &&
      document.getElementById("dataRitiro").style.display == "block"
    ) {
      if (isDataPassata(dataRitiro)) {
        setErrorMessage("Selezionare una data valida per il ritiro");
        window.scrollTo(0, rec.top + window.scrollY - 200);
        return;
      }
      json.Documento.DataRitiro = format(dataRitiro, "yyyy-MM-dd HH:mm:ss.SSS");
    }
    json.Documento.AttendiInArrivo = parseInt(
      document.getElementById("attendiInvio")
        ? document.getElementById("attendiInvio").value
        : 0
    );
    json.Documento.Note1 = document.getElementById("messageGreen")
      ? document.getElementById("messageGreen").value
      : "";
    json.Documento.Note2 = document.getElementById("messageYellow")
      ? document.getElementById("messageYellow").value
      : "";
    json.Documento.Note3 = document.getElementById("messageRed")
      ? document.getElementById("messageRed").value
      : "";
    json.Documento.TotSpeTra1 = parseFloat(TotSpeSpe1);
    json.Documento.TotSpeInc1 = parseFloat(TotSpeInc1);
    json.Documento.TotSpeImb1 = parseFloat(TotSpeImb1);
    json.Documento.TotSpeTra2 = parseFloat(TotSpeSpe2);
    json.Documento.TotSpeInc2 = parseFloat(TotSpeInc2);
    json.Documento.TotSpeImb2 = parseFloat(TotSpeImb2);
    json.Documento.speTra = speTra;
    json.Documento.IDModPag = pagamento?.IdPag;
    if (!json.Documento.IDModPag && global.aziendaID == 2) {
      alert("Selezionare un valore consentito dal menu a tendina");
      return;
    }

    if (global.aziendaID == 1)
      json.Documento.flgWebPos = document.getElementById("flgWebPos").checked;
    //console.log(JSON.stringify(json))
    setIsCaricamento(true);
    var result = await fetchSendCheckout(json);
    //var result = {};
    //await sleep(1000)
    setIsCaricamento(false);
    if (result.Errore && result.Errore != "") {
      addToast(result.Risposta, {
        appearance: "error",
        autoDismiss: true,
        placement: "bottom-left",
      });
      if (result.Errore.includes("Data")) {
        setErrorMessage(result.Risposta);
      }
    } else {
      removeAllFromCart();
      setCartItems({});
      addToast(result.Risposta, {
        appearance: "success",
        autoDismiss: true,
        placement: "bottom-left",
      });
      await sleep(4000);
      if (global.aziendaID == 1) history.push("/");
      if (global.aziendaID == 2) history.push("/shop-grid-full-width");
    }
    sessionStorage.setItem("notShowInventario2022", true);
  };
  function getTotGreen() {
    var tot = 0;
    cartItems.map((item) => {
      tot += item.qtyOK;
    });
    return tot;
  }

  function getTotYellow() {
    var tot = 0;
    cartItems.map((item) => {
      tot += item.qtyArr;
    });
    return tot;
  }
  function getTotPre() {
    var tot = 0;
    cartItems.map((item) => {
      tot += item.qtyPre ? item.qtyPre : 0;
    });
    return tot;
  }

  function getTotRed() {
    var tot = 0;
    cartItems.map((item) => {
      tot += item.qtyNO;
    });
    return tot;
  }

  function getTotPriceGreen() {
    var totPrice = 0;
    cartItems.map((item) => {
      totPrice +=
        item.qtyOK != 0
          ? item.qtyOK *
            calcolaPrezzo(
              item.priceNoSco,
              item.pricesco,
              item.priceIva,
              item.id,
              item
            ).toFixed(2)
          : 0;
    });
    return totPrice;
  }

  function getTotPriceYellow() {
    var totPrice = 0;
    cartItems.map((item) => {
      totPrice +=
        item.qtyArr != 0
          ? item.qtyArr *
            calcolaPrezzo(
              item.priceNoSco,
              item.pricesco,
              undefined,
              item.id,
              item
            ).toFixed(2)
          : 0;
    });
    return totPrice;
  }
  function getTotPricePre() {
    var totPrice = 0;
    cartItems.map((item) => {
      totPrice +=
        item.qtyPre != 0
          ? item.qtyPre *
            calcolaPrezzo(
              item.priceNoSco,
              item.pricesco,
              undefined,
              item.id,
              item
            ).toFixed(2)
          : 0;
    });
    return totPrice;
  }

  function getTotPriceRed() {
    var totPrice = 0;
    /*cartItems.map((item) => {
      totPrice += item.qtyNO != 0 ? item.qtyNO * (item.priceNoSco.toFixed(2) * (1 - personal.S1/100) * (1 - personal.S2/100)).toFixed(2) : 0
    })*/
    return totPrice;
  }

  function calcolaDate() {
    var endpoint = global.endpoint + "/pegaso/getDateRitiro";
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: "{IDCli:" + idCli + "}",
      withCredentials: false,
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result)
        var d = result.DateAbilitate.map((data) => {
          return data.Data;
        });
        setDatesForEnable(d);
        setDataRitiro(null);
        setProxRitiro(result.ProxRit);
        d = result.Date.map((data) => {
          return data.replaceAll("'", "");
          //return data.DatRit
        });
        setDatesForDisable(d);

        if (result.ProxRit) {
          var filtered = d.filter(function (value, index, arr) {
            var dataRitiro = format(new Date(result.ProxRit), "MM-dd-yyyy");
            var datepart = result.ProxRit.split("-");

            return value != format(new Date(result.ProxRit), "MM-dd-yyyy");
          });
          setDatesForDisable(filtered);
          setShowDialogProssimoRitiro(true);
        }
        setDateCaricate(true);
      });
  }
  const ModalSpedizioni2maggio = () => {
    return (
      <Modal show={showDialogSpedizioni2maggio} transparent={true} size="xl">
        <div>
          <button
            style={{
              marginLeft: "95%",
              width: "5%",
              background: "transparent",
              borderColor: "gray",
              borderRadius: "50",
              border: "none",
            }}
            onClick={() => setShowDialogSpedizioni2maggio(false)}
          >
            <i className="fa fa-times" />
          </button>
        </div>
        <div
          style={{
            textAlign: "center",
            font: "20px Helvetica, sans-serif",
            color: "rgb(0, 0, 0)",
            padding: "20px",
          }}
        >
          {" "}
          <img
            style={{ width: "100px" }}
            src="data:image/png;base64,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"
          />
          <h1 style={{ fontSize: "30px" }}>Comunicazione</h1>
          <p>
            <span>
              Gentile Cliente, gli ordini effettuati con modalità{" "}
              <strong>"Ritiro in sede"</strong>
              <br />
              <u>saranno disponibili quando sono in stato 'Pronto'.</u>
              <br /> Verifica lo stato del tuo ordine nella sezione{" "}
              <strong>"I miei documenti" - Ordini</strong>.
              <br />
              Buon Lavoro.
            </span>
          </p>
          <p>Lo staff DGA</p>
        </div>
      </Modal>
    );
  };
  const ModalProssimoOrdineRitiro = () => {
    return (
      <Modal show={showDialogProssimoRitiro} transparent={true} size="xl">
        <div
          style={{
            textAlign: "center",
            font: "20px Helvetica, sans-serif",
            color: "rgb(0, 0, 0)",
            padding: "20px",
          }}
        >
          {" "}
          <img
            style={{ width: "100px" }}
            src="data:image/png;base64,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"
          />
          <h1 style={{ fontSize: "30px" }}>Comunicazione</h1>
          <p>
            <span>
              Hai già un ritiro prenotato per il giorno{" "}
              {new Date(proxRitiro).toLocaleDateString("it-IT")}.
            </span>
            <br /> Vuoi ritirare nella stessa giornata? <br />
            <button
              type="button"
              class="btn btn-success mr-10"
              onClick={() => {
                setDataRitiro(new Date(proxRitiro));
                setShowDialogProssimoRitiro(false);
                setShowDialogSpedizioni2maggio(true);
              }}
            >
              Si
            </button>
            <button
              type="button"
              class="btn btn-danger"
              onClick={() => {
                setShowDialogProssimoRitiro(false);
                setShowDialogSpedizioni2maggio(true);
              }}
            >
              No
            </button>
          </p>
        </div>
      </Modal>
    );
  };
  const ModalSpedizioniControlloCAP = () => {
    return (
      <Modal
        show={showDialogSpedizioniControlloCAP}
        transparent={true}
        size="xl"
      >
        <div>
          <button
            style={{
              marginLeft: "95%",
              width: "5%",
              background: "transparent",
              borderColor: "gray",
              borderRadius: "50",
              border: "none",
            }}
            onClick={() => setShowDialogSpedizioniControlloCAP(false)}
          >
            <i className="fa fa-times" />
          </button>
        </div>
        <div
          style={{
            textAlign: "center",
            font: "20px Helvetica, sans-serif",
            color: "rgb(0, 0, 0)",
            padding: "20px",
          }}
        >
          {" "}
          <img
            style={{ width: "100px" }}
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAChCAMAAABK+nL1AAAA81BMVEUAAAD///9ytivjBhO5ubn7+/vV1dV1uywdLgsUFBRTU1Ovr68aGhpgYGC3BQ/Dw8MIDQNinSU8PDw0NDTu7u7iBRJQgR4mJiZFbRnpBhOioqIZGRmJiYnq6uoNDQ1AAQVyAwrS0tI8YBazs7NJSUl+fn7h4eE1NTUtLS0/Pz9lZWWSkpIhISGAgIBUVFTLy8tvb29trinSBRHEBRAPGAV/AwoZAAI1VRQ1AQSZmZldlSMhNQytBA4mAAMcAQINFQWRBAwTHwdOAgZhAgieBA1WiiBKdRw7AQUsRxCLBAtdAgc3WBRKAgYgNAwOAAAtAQMoQA98MVN1AAASNElEQVR4nO2dCZuayBaGsRUNKDFRjLGlSdsi4o6dZWIyyWRf53bm//+aCxRLUZxTFEhP7k38niczMUJRvFadOnVqk6STTjrppJNOOumkk07639G9Iqr20cqw5x66tl7zpNu7tqHNh0q1j6hWd+6L68WLjx8/fX9ZDbK+0bXlGivd7q4WlaQf6fMjRJ+Lp3WndVZMrVZr//DOkcCUmZ7hlEg+DM3j0k/0fITqBrzBVBQFe3phWATY/sGX8i+w7GaLFKOJMS6fPq2vozqmS+j62aQ77TYNOLFSsIj+KJd9lVeoKK0qKV04q8GfwOU7e+3912zo4MOPgNXal8C1nYih8qTPjsf1bTRAaV0/y1w+bUqbaXs6kxoT6NlHwPK0v1Ms74o4Kl8X/XKIEj1GUdXro2/s1Y5sSQ3XNGuWWXOA1I6Ddda6KmLqtVxbxco4rnC9usYLVr3+mL3cqplS41zbXAwlewskdySss7MX4rQaRVF5so+i9Z6DyitaryBYK2PiOXu6ehuwzvZPxDK+tkuw8vyIY6riXT6sr2wWZVdqLKWdKw1rw1uBJWi45oKNYJaWVZrVa7wt9DV4zLpaG9mcWdKw3bfbUHoVwDrb/5Wf70VJVL5K03rDh1Uf/GDvWOlbzym17AaYXhWwBGriorBpp6RDLZOAbnjWPaiHl5l75kaj0TggPa5KYJ19zMn28AhUvsq58+/yYNWviyVYDazWQ+5D1mXtVaRdKVhv8lgNRsV609XAOjv7h/eQyZGsPH+rDKzrPFj1OtTluX1Y9znPOD+aVSkj/4jT1YmKFtDl+Rdgtb6jj9hWwKpmF48KPq7nwqoP/v4ZsM5amCdvlnNGWblFWb3KL1ie3vwUWGefkCdUUQl9Fe33PBVA5RWtnwMLcU17uRT0C9vTRZ4nBvrUuG7uihSswejd0bBatARhteDo1pSPQD5XnbFfaDq92QWfKdRbw/VaqGABoYeisO4/SOnFfr8XKVpQ+nx3VE67BC7XH5sVgvU0p6sTFa0BG3ooCusBe9W9t/9cvcgrYi3I1+ryXn/KFpbOgVe0CsESqYQBrcuqYQV6+yKH1ovsPX0eK8jTdDnXQ/E4TO+E2kJfBfzSArAk6SW/dAEmntcUHsBnbHFD3xR/LelPQVSe4CExSIVgSdJDLq3/sJcrHB8La9009A5Z3MQ/48aTU9UQCD1gKghLuuLRumKv5vgNF6hLjtutpfBr/S1m3gOJhx6KwpK+c2hljBanFnI88h12z7nwaxWohQVCD4VhSR9xWC32WpwVr2mzMLNli77VDWjeB3W4t8iG4lEVh/UEL1otxmhxYsnQ4EkkvDcp2pt+CsIawU59NhSPqTgsTkVsMUYLtz4X3J7eCrtNE3wr0LwPRn/Doz2ZITFMJWBJ99GixRitJgpryn1A/xyRIKzncFM4QGKnmSExTGVgXaGw0j2eMd7ZKxxwKaRLkEn9jfQNpjgSTLcMrDs4rJRb2sf9y5LjNYJC4snvpFeghRcOPZSBJaHd6v1b+jILZVUrSUFMn2En6/oVilGwy1MK1gPMxO9TzSHez+uWxCCmP2FYfjAGjkWIhuJLwfqCtoepwAPeGJYarBHV6wFomQIzjsSaR4+EUi4FC3e1UpMn8VkzReIHhQVb8cHouf8lUg8/CKVcCpaEwkpFS/Fe9K3a9w8wjwHvS2Q2LqNysFALn4KFxz0rm4wM6AbBQZyp98i3lyJJl4OFuqWp0UOUFdQYLtqFNQWnbr1HzBLpLiP+qlgo/qfAkoEk8TAWLnCYGrZKUYN3gxit68zso38Xlom+JBRyqArWZ7hgDe6G3yN+Rf39rcFCbRYNS/kpsL7CLOpPw+/fIbDuAmlVAwtjlTLwOKyL24N18xhxHOJqhsAaCfilt+g6/BRYPxAWSewYDqIOREIPpWC9FXJKcVi3aOA/wLBGT+MrLuErBgKzHm6zu4O/5a3BusEqWRLfw4Jdg/wuTylYn8Q60vhbAk5pNbDeI8WGihyjo2RPM6lVAkswRFMonFUNLGSVwOBD/jUCfmkZWG9xWKngH943BMLDlcB6jU0jpb0ozGiNcv3SMrC+YKyYsDI6/geN3FcC6xvCoU4PSbxGpkGMckMPZWDhI4fpabj4ECswAFgJLGzFXHrQGSt+uaGHErBwx4GZDr/BXzNr4auA9QPp6jAxBXTqVl6XpwQsfCSMmaHFmaacNc1VwEKCVax3/hyDlVcPi8P6A2XFzlju4c3h6jZg3WBOAdPOPcPq4XVOPSwM6y/OjElmouQQj/7tMvWwAliPsGlGbE8Gcx7yhsSKwrrHm13KzO7mzYBfswlvLyihlPXUVQwsbK3OgN3RAbkuN/RQENYT3GCdMcMVEnedb6YemuNECto0aGNaTPEUnb+GajB6XSGslzxUjP8u8SeIcsPwqIfGm3zD25ZAVPwuTxFYL9HBVaLMYic87oDNKCVy0Lt4sHjbEogWrbtcEy8M6973vLnwwKJDfBpNTc9YrUT4fHAOrB/w2GoxWPxZ8fCigStGnz7u81datLKLf3n1EJ91xHE5OLCQqTPFNOL6pdWt3YHW/g55C3I2WJ445ZEDi78tgai4s3ErhPUym7qJ96XxPQh4c+dxWM8KzE/GFQ7y3zqs+9CCwxnnxRFanB4lD9bXCtpCX7wuT3WwwDXl+NhhICCuxcXLgVURqwGvy1MdLHglq8GnNe0wcHP2q0FhvRNY4ytGixOKr2yNNLKXlpm3S8GG8k7N3OXUKKwPFbHizoqvbPU9tkSatygukNzYqI5iSh3L4DSDObCwKQwlxBkSqwoWugVgJxdAEWGwiqzVyREn9FDRjiGc/VV4jmllsKpxsojw0EM1sPa8Hcd4vlZRIfMrX1VXsLwuDxp6qAYWd3OV/PX34kKWWGDbEgzq+DalqK8xyOwFWCUsdskOK66bWQUsfFuC60tUyKyIOscvrQJW7qSbMpv9FYH1CmPF6xdz+keYX3o8rFb+FokKf8eGo2GhY1sD3qQrLP41QBEfD4u3v1GkzjEbs+XDQq0PN5aHx3Sw0MOxsFofhbbedApvN6aDdReEhW9LwI0Sf0YZY6GHY2Hl2quIVlFYLhipAWHhThYv3oIPH6KQj4QlvrvysNjOUBM4rAXBeo1uS5Czrh5ddY5V36Ng3RfczzUQNxDISjaltiisd2htuuTnCJlz4wkZEisPq7Xn74qYlSFs5v3NNsHtkSBYaAHJnRWDw4LrYWlYrQdFihXRMD+sQMqVvzWIKCxsGqnAkkt89wc49FAOVmv/seDm5qE2Ih7XJNiRQBQW7mRd5uUGW0DgL9SvClZr/50dexbW2M2ti+Ge+aKwsDZtkN0MmBU6qxLp8hSGtd8/KFeoYrm8HevkSbQ7DzjSmoWFTp0R2GPmBnc6HkO+/51WAd1/cPVP6TJFqTdDWkZ91YsvAi/Jwnp/F5PA0qVL9Oa7ULF88lBIV398uSOwN3cBaW1dlqkiJst6OzU0toGWGPaw5H55KX11OTOM1WplzJYWZ+7DSSeddNJJJ5100v+j/NNATsoouwTEV3XDVL+U4CNGfjlY1QwkwTt8/XKwqjnZ4DeBxd0oXFi/CaxgHbtsByp/ONLvAcsO1rFfOIpiKmYH3R42T78IrFQUjJHe3R2kw06vXaylzlBxlHHOBGBUKCzd8v6jksmfdjNRnCk9+AiNkpILmc+T6LWCDzqTKrlEpm5PfcGvOfJh25v3VGqiauPgK/zJw5P2lJm+ljTDOliGEWYjUvQSmRw1m6mxFLxkaVLNCBeBzOnvhg2ZygOw1jTcVCZ+jEx2ig7HRyfBB791ym56YVOXp8Q99CJZShYPwZKJk2oEy1TnmrOU5LU0t4bboWVkNqBaXmTeU8q+Hw6rKalmeCkTt13YXFhh5uOyLpNp7fMQlhnByu43Z1OXC8Oiw85LGJaytGa9jenBspZ9t69lYUmmkX1POsUcWP4pLTUQFpnQgcIKIcTnxYRvbzZvBVY6b0sQltkfLjoLv2S55+pUPd9AW5sdjoJVi3cVzyTicmDF2YjqYfT2xm3AYrpr4S/CwtIsdz6LStZ8CZSsIL/HwDIjvzebiI3Dik8ujQZEo7cf3wKszGGjGgRLcbcra6V4sBae7XK2MCzrKFjz6HWziWxwWPGKwWh1Uvz2UzFYwPGhKKxwS5ahpkV5hGCZam/pLP2SpXolrOfCsMyjYMW+C0nED1K0w1NcVRmDlSyBi86njWENIVibJAIyDW6Q+x1fpE00g7+bKKzz+Elyl8o6C2s+tNZWaLPa6iG2Weu2/9zw5zWbqhI8jnwc+38dp1Y38GDp0ZB6L/nNwsanj8OK1yiZLKxgPJmFhZ2xZmd/WEBunG40ML0BYCmutVkYZtZ1cGQaQpSV5JdlxIHlrhXiJKRgkZdY6xgsKubTZWHNCsBqwskzIoBILlfJHVlYBoHlG3rKwEezWslUishNI7AARxiHdZBmjfUwA4skNUZhBWcGOQ71XQKrUzksckIR2ZD/YufLTmBtI1jmwlGHql8NYw8+DUtNZaUErMXCd7d3GVgKH1bAYrmk7qCat2nVsMI95PtMvIq8vEX2XWmHHnxg4D3nlDLwESxiWyLLWByW7Hi2zSbeQ7ZkodWQvGObnPm1o2CZYdFiYZ3rseRsQnmwkkq/pHupzDqxsaG11fbYg9XbOpqjZmAFBSDeJac4rJrl+N82WVgkew5m4Inh0EleNhQsN/zxOK5DqpCJwdIpp8wx4u4oA4t2HdIli850bNJLwGpLi1loDShY4aFvFgYryOY6PGudHFlFYK0CW7zkwUoFhsRgpY+fib1oFpbX3VkvAJtl9jwtwqk6cVUuAavWXszD6YsElrbdbtXQMXARp5SckeqGlpec2E5gGUG4oaNXDIs5sU+TIViKq0atIdaRpo+oLAMrGRPJerZTBBbZILkbfUv1Xww5aCHbzWph1fR0XGUGwtpo59Y5v7tDnbpYApZ+Qf5AsPydikBYQXjGvIioGRQsUmPWdmlYyW6T6ZWdy1QAbALAMnuRB68Zi5W1gWBREzBLwHK9LLm0zWJSBmEFV/ptDKmPDg2L8FuVNvDJ4e3MQUf2ipog2INgxX7WdtYzFmDfkOpSlYClea3Dcg7CCso6CCv4N1WOu4gyBYt4M8PSfhYKy9MuMqbkLDICyzE2ngyNqoZMa0gr6d9UCWtNmg0IFnGv1ltV3ZIf+5yGRZ01WzUsr96TIiuZkxrjwXf9SOmGREpVd07DUrTlcqmF6cZFqwpYli/VjdKEYGUmWas0LDmpeBXBahq+pnSGgndmow7Oej6eS0DfkDRhc5ptOZtlel2ejJ+VCIAlZ8Yg/EfGsKjNsUrBiuMZ8eGb7RQ7B4WlLdy5C8SzQg+evMr4CFhTqbMOO+KisOzMwIzfhUhgJe1ZGVhyZugq7E5EpwAGNjFYlMdGHQztnHR34KgDCSvFO+SUgFVruMswaMGBpdqx5CSinGhKw6otsrAOSQI2PUgn5GeFo247+pWbWVim5XWkNSlrs1IhmmP6hpQ4sCQzlg0dfamlYMUmPoFlUqLDkmJOKWlGyBJPsnFIJ2kNqdGddY+M7rB9w5DINsachtVWOh2zvfAMkuF3pXBY9mS3a+bDSmSHnfdZKPJDp2DFvhUcgy8OKzrmr69FrhXlZyXVcLZdWQclrIYALDdBnoLVPCzG5/ZQWnmvduAaeKmjmNMisOwkt75IGzNJwYpGrqqCZZtsGlM+rHTfMIIVtDwmFM9yPb967ThNSeHCWnqtw1ArAOtik37jZfiRhhW9XFWwMs4K6Q7Dg6w134NfGItZBtYh4czC8hyozsFUnQUflnlYmbmtIQ3LiTlQORimYEUmvjJYejrqEBrpjIHv+wbe+1vQ3cnCaqRynoHVHErteU41dDqBOywKa0cch7hdJ1NAFDsFa1cxrLRvF+Y3DasbuQ5ewXaGnvwuSBoWMSDRXkIpWH413B2kGh+WXw3XJOJhKZ5YWF1TSclsd/z/UUNIa//zuCs7/rfxVABybZRqKoUULJP9F4yWEXWjx27U3JOOaeSsnkvDcV/pp15AD3K/iG4Ish7CrQVfzclXtod/osvNmj/5iANL8R5Kflk5UCaXjDKXRZ9T/5xcxN7PPAJ+KKimoVmaMUku1tMbyNvBdK30hD8ZyRXvyRzXYUf+nBTrF5km+e/oBKuAYFjcaYm/ryYgrJNOOumkk0466aSTTvo5+i9hAiv7gIbMOAAAAABJRU5ErkJggg=="
          />
          <h1 style={{ fontSize: "30px" }}>Comunicazione</h1>
          <p>
            <span>
              Gentile Cliente, al fine di eseguire correttamente la spedizione
              <br />
              <u>
                ti invitiamo a controllare i dati della stessa (CAP, Località e
                provincia) <br />
                nella form a sinistra di questa pagina e modificarli cliccando
                il pulsante <strong>Modifica dati</strong>.
              </u>
              <br />
              Qualora riscontrassi un'anomalia e/o manca la località,
              contattaci.
            </span>
          </p>
          <p>Lo staff DGA</p>
        </div>
      </Modal>
    );
  };
  const numGiorniLavorativi = (date) => {
    var d = new Date();
    var dateComp = new Date(date);
    while (d < dateComp) {
      if (!hd.isHoliday(d) && d.getDay() != 0 && d.getDay() != 6) return false;
      d.setDate(d.getDate() + 1);
    }
    return true;
  };
  const isDisabled = (date) => {
    //console.log("date disabilitate" + datesForDisable)
    var disabled =
      date.getDay() == 0 ||
      date.getDay() == 6 ||
      datesForDisable?.find((d) => {
        var datepart = d.split("-");
        //console.log(new Date(datepart[2] + "-" + datepart[0] + "-" + datepart[1] + " 00:00:00"))
        return (
          new Date(
            datepart[2] + "-" + datepart[0] + "-" + datepart[1] + " 00:00:00"
          ).getTime() == date.getTime()
        );
      }) ||
      hd.isHoliday(date) ||
      date.toDateString() === new Date().toDateString() ||
      numGiorniLavorativi(date);

    if (
      datesForEnable?.find((d) => {
        var datepart = d.split("-");
        return (
          new Date(
            datepart[2] + "-" + datepart[0] + "-" + datepart[1] + " 00:00:00"
          ).getTime() == date.getTime()
        );
      }) &&
      disabled
    ) {
      return false;
    } else {
      return disabled;
    }
  };
  const calcolaPrezzo = (prezzoNoSco, prezzoSco, priceIva, id, item) => {
    console.log(priceIva);
    if (priceIva) return priceIva;

    var itemSenzaSconto = itemsNoSco.find((itemS) => itemS.IDArtBas === id);
    if (itemSenzaSconto) {
      if (item.pricesco != item.priceNoSco) return prezzoSco;
      else return prezzoNoSco;
      /*if (prezzoSco < prezzoNoSco) return prezzoSco;
      return prezzoNoSco;*/
    }
    var pre = prezzoNoSco * (1 - personal.S1 / 100) * (1 - personal.S2 / 100);
    if (pre > prezzoSco) return prezzoSco;
    else return pre;
  };
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.checkout} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.checkout + " " + strings.siteContent}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Checkout
      </BreadcrumbsItem>
      <LayoutOne>
        {/* breadcrumb */}
        {/*<Breadcrumb />*/}
        {/*<ModalSpedizioni2maggio />*/}
        {/*<ModalSpedizioniControlloCAP />*/}
        <ModalProssimoOrdineRitiro />
        <div className="checkout-area pt-95 pb-20">
          <div className="container" style={{ maxWidth: "1300px" }}>
            {cartItems && cartItems.length >= 1 ? (
              <div className="row">
                <div className="col-lg-7">
                  <div className="billing-info-wrap">
                    <h3>Dettagli di Fatturazione</h3>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="billing-info mb-20">
                          <label>Ragione Sociale</label>
                          <input
                            disabled
                            type="text"
                            defaultValue={
                              cliente.RagSoc
                                ? cliente.RagSoc
                                : userData.user.user.RagSoc
                            }
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>Nome</label>
                          <input
                            id="Nom"
                            nome="Nome"
                            nomeField="Nome"
                            defaultValue={cliente.Nome}
                            type="text"
                            className="data"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>Cognome</label>
                          <input
                            id="Cog"
                            nome="Cognome"
                            nomeField="Cognome"
                            defaultValue={cliente.Cog}
                            type="text"
                            className="data"
                          />
                        </div>
                      </div>

                      {/*<div className="col-lg-12">
                        <div className="billing-select mb-20">
                          <label>Stato</label>
                          <select defaultValue="Italia"
                            nome="Stato"
                            nomeField="Stato"
                          >
                            <option>Select un Paese</option>
                            <option>Italia</option>
                            <option>Azerbaijan</option>
                            <option>Bahamas</option>
                            <option>Bahrain</option>
                            <option>Bangladesh</option>
                            <option>Barbados</option>
                          </select>
                        </div>
            </div>*/}
                      <div className="col-lg-12">
                        <div className="billing-info mb-20">
                          <label>Spedisci a</label>
                          <input
                            className="billing-address"
                            placeholder="House number and street name"
                            type="text"
                            id="dessedcli"
                            defaultValue={
                              sede?.dessedcli ? sede?.dessedcli : "IDEM"
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="billing-info mb-20">
                          <label>Indirizzo</label>
                          <input
                            className="billing-address"
                            placeholder="House number and street name"
                            type="text"
                            id="ind"
                            defaultValue={sede?.IndSed}
                          />
                          <i
                            className="pe-7s-search"
                            style={{ display: "none" }}
                            onClick={() => checkAddress()}
                          />
                          <Autocomplete
                            style={{ display: "none" }}
                            className="data"
                            id="country-select-demo"
                            options={addresses}
                            autoHighlight
                            value={address}
                            onChange={() => checkAddress()}
                            //onChange={(event, value) => setSede(value)}
                            getOptionLabel={(option) => option.address_line1}
                            renderOption={(option) => (
                              <React.Fragment>
                                {option.address_line1}
                              </React.Fragment>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="billing-info mb-20">
                          <label>Località</label>
                          <Autocomplete
                            className="data"
                            id="country-select-demo"
                            options={localita}
                            autoHighlight
                            value={sede}
                            onChange={(event, value) => setSede(value)}
                            getOptionLabel={(option) =>
                              option.Loc + " (" + option.CAP + ")"
                            }
                            renderOption={(option) => (
                              <React.Fragment>
                                {option.Loc + " (" + option.CAP + ")"}
                              </React.Fragment>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                          <input
                            type="text"
                            defaultValue={sede?.Loc}
                            id="loc"
                            disabled
                            style={{ display: "none" }}
                            className="data"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>Provincia</label>
                          <Autocomplete
                            className="data"
                            id="country-select-demo"
                            options={localita}
                            autoHighlight
                            value={sede}
                            disabled
                            onChange={(event, value) => setSede(value)}
                            getOptionLabel={(option) => option.Pro}
                            renderOption={(option) => (
                              <React.Fragment>{option.Pro}</React.Fragment>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                          <input
                            type="text"
                            defaultValue={sede?.Pro}
                            id="pro"
                            disabled
                            style={{ display: "none" }}
                            className="data"
                            maxLength="3"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>CAP</label>
                          <Autocomplete
                            className="data"
                            id="country-select-demo"
                            options={localita}
                            autoHighlight
                            value={sede}
                            disabled
                            onChange={(event, value) => setSede(value)}
                            getOptionLabel={(option) => option.CAP}
                            renderOption={(option) => (
                              <React.Fragment>{option.CAP}</React.Fragment>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                          <input
                            type="text"
                            defaultValue={sede?.CAP}
                            id="cap"
                            disabled
                            style={{ display: "none" }}
                            className="data"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>Numero di Telefono</label>
                          <input
                            id="num"
                            nome="Cel"
                            nomeField="Cel"
                            defaultValue={
                              userData.user.user.Cel
                                ? userData.user.user.Cel
                                : cliente.Tel
                            }
                            type="text"
                            disabled
                            className="data"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="billing-info mb-20">
                          <label>Indirizzo Email</label>
                          <input
                            id="mail"
                            nome="Mail"
                            nomeField="Mail"
                            defaultValue={
                              userData.user.user.EMail
                                ? userData.user.user.EMail
                                : cliente.Email
                            }
                            type="email"
                            disabled
                            className="data"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="your-order-area" id="edit">
                    <div className="place-order mt-25">
                      <button
                        className="btn-hover"
                        onClick={() => {
                          setDisable(false);

                          var elementi =
                            document.getElementsByClassName("data");
                          Array.from(elementi).forEach(
                            (input) => (input.disabled = false)
                          );
                          document.getElementById("reset").style.display =
                            "block";
                          document.getElementById("edit").style.display =
                            "none";
                        }}
                      >
                        Modifica dati
                      </button>
                    </div>
                  </div>
                  <div
                    className="your-order-area"
                    id="reset"
                    style={{ display: "none" }}
                  >
                    <div className="place-order mt-25">
                      <button
                        className="btn-hover"
                        onClick={() => {
                          setDisable(true);
                          var elementi =
                            document.getElementsByClassName("data");
                          elementi.forEach((input) => (input.disabled = true));
                          document.getElementById("Nom").value = cliente.Nom
                            ? cliente.Nom
                            : "";
                          document.getElementById("Cog").value = cliente.Cog
                            ? cliente.Cog
                            : "";
                          /*document.getElementById("dessedcli").value = sede.dessedcli ? sede.dessedcli : "IDEM"
                        document.getElementById("ind").value = sede.IndSed ? sede.IndSed : ""
                        document.getElementById("loc").value = sede.Loc ? sede.Loc : ""
                        document.getElementById("pro").value = sede.Pro ? sede.Pro : ""
                        document.getElementById("cap").value = sede.CAP ? sede.CAP : ""*/
                          setSede(originalSede);
                          document.getElementById("num").value = cliente.Tel
                            ? cliente.Tel
                            : userData.user.user.Cel;
                          document.getElementById("mail").value = cliente.Email
                            ? cliente.Email
                            : userData.user.user.EMail;
                          document.getElementById("reset").style.display =
                            "none";
                          document.getElementById("edit").style.display =
                            "block";
                        }}
                      >
                        Resetta dati
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5">
                  <div className="your-order-area">
                    <h3>Il Tuo Ordine</h3>
                    <div
                      className="your-order-wrap gray-bg-4"
                      style={{ padding: "10px" }}
                    >
                      <div className="your-order-product-info">
                        <div className="sidebar-widget-list-left"></div>
                        {totPortoFranco > 0 ? (
                          <p
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              backgroundColor: "pink",
                              border: "1px red solid",
                              borderRadius: "10px",
                              padding: "5px",
                              display:
                                global.importoPortoFranco > 0
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Aggiungi altri {(390.0 - tot).toFixed(2)} € per la
                            spedizione gratuita
                          </p>
                        ) : (
                          <p
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              backgroundColor: "pink",
                              border: "1px red solid",
                              borderRadius: "10px",
                              padding: "5px",
                              display:
                                global.importoPortoFranco > 0
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Complimenti! Hai la spedizione gratuita per questo
                            ordine!
                          </p>
                        )}
                        {/*<table style={{lineHeight:"30px"}}>
                    <tr>
                      <th>Prodotto</th>
                      <th style={{minWidth:"70px", textAlign:"right"}}>Disp.</th>
                      <th style={{minWidth:"70px", textAlign:"right"}}>Totale</th>
                    </tr>
                    {cartItems.map((cartItem, key) => {
                      return (
                        <tr>
                          <td style={{maxWidth:"280px"}}>{cartItem.name}</td>
                          <td style={{minWidth:"70px", textAlign:"right"}}>
                            <div style={{display:"block"}}>
                              <table cellspacing="0" style={{textAlign:"center", width:"100%",lineHeight:"15px"}}>
                                <tr title="Quantità attualmente disponibili"><td>🟢</td><td>{cartItem.qtyOK}</td></tr>
                                <tr title="Quantità in arrivo"><td>🟡</td><td>{cartItem.qtyArr}</td></tr>
                                <tr title="Quantità non disponibili"><td>🔴</td><td>{cartItem.qtyNO}</td></tr>
                              </table>                            
                            </div>
                          </td>
                          <td style={{minWidth:"120px", textAlign:"right"}}>{"€ "+cartItem.pricesco.toFixed(2)}</td>
                        </tr>
                      )
                    }) 
                  }
                </table>*/}
                        {getTotGreen() > 0 && (
                          <div
                            style={{
                              backgroundColor: "rgba(111,247,148,0.15)",
                              marginBottom: "30px",
                              padding: "10px",
                            }}
                          >
                            <table style={{ width: "100%" }}>
                              <tr
                                style={{
                                  fontSize: "18px",
                                  borderBottom: "0.5px solid gray",
                                }}
                              >
                                <td
                                  style={{
                                    minWidth: "100px",
                                    maxWidth: "280px",
                                  }}
                                >
                                  Art. disponibili
                                </td>
                                <td
                                  style={{
                                    minWidth: "70px",
                                    textAlign: "right",
                                  }}
                                >
                                  Disp.
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    textAlign: "right",
                                  }}
                                >
                                  Prezzo{" "}
                                  {global.aziendaID == 2 ? (
                                    <span style={{ fontSize: "12px" }}>
                                      (i.i.)
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{
                                    minWidth: "70px",
                                    textAlign: "right",
                                  }}
                                >
                                  Totale{" "}
                                  {global.aziendaID == 2 ? (
                                    <span style={{ fontSize: "12px" }}>
                                      (i.i.)
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                              {cartItems.map((cartItem, key) => {
                                var popup =
                                  cartItem.pricesco != cartItem.priceNoSco
                                    ? cartItem.priceNoSco + " - "
                                    : "";
                                popup +=
                                  cartItem.sco1 != 0
                                    ? cartItem.sco1 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco2 != 0
                                    ? cartItem.sco2 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco3 != 0
                                    ? cartItem.sco3 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco4 != 0 ? cartItem.sco4 : "%";
                                popup = popup.substring(0, popup.length - 1);
                                if (cartItem.tipoSconto == 1)
                                  popup = cartItem.priceNoSco; //se prezzo fisso
                                return (
                                  cartItem.qtyOK != 0 && (
                                    <tr
                                      style={{
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      <td style={{ maxWidth: "280px" }}>
                                        {cartItem.name}
                                        <br />
                                        <span
                                          style={{
                                            fontSize: "10px",
                                            display:
                                              cartItem.variation.length > 0
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {cartItem.selectedProductColor} /{" "}
                                          {cartItem.selectedProductSize}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          maxWidth: "280px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {cartItem.qtyOK}
                                      </td>
                                      <td
                                        title={popup}
                                        style={{
                                          maxWidth: "120px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {"€ " +
                                          calcolaPrezzo(
                                            cartItem.priceNoSco,
                                            cartItem.pricesco,
                                            cartItem.priceIva,
                                            cartItem.id,
                                            cartItem
                                          ).toFixed(2)}
                                      </td>
                                      <td
                                        style={{
                                          minWidth: "120px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {"€ " +
                                          (
                                            calcolaPrezzo(
                                              cartItem.priceNoSco,
                                              cartItem.pricesco,
                                              cartItem.priceIva,
                                              cartItem.id,
                                              cartItem
                                            ).toFixed(2) * cartItem.qtyOK
                                          ).toFixed(2)}
                                      </td>
                                    </tr>
                                  )
                                );
                              })}
                              <tr
                                style={{
                                  borderTop: "1px solid gray",
                                  fontWeight: "bold",
                                }}
                              >
                                <td style={{ maxWidth: "280px" }}>
                                  TOTALE{" "}
                                  {global.aziendaID == 2 ? (
                                    <span>(i.i.)</span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{
                                    maxWidth: "280px",
                                    textAlign: "right",
                                  }}
                                >
                                  {getTotGreen()}
                                </td>
                                <td></td>
                                <td
                                  style={{
                                    minWidth: "120px",
                                    textAlign: "right",
                                  }}
                                >
                                  {"€ " + getTotPriceGreen().toFixed(2)}
                                </td>
                              </tr>
                              {/*<tr style={{ borderTop: "1px solid gray", fontWeight: "bold" }}>
                                <td style={{ maxWidth: "280px" }}>Spedizione</td>
                                <td style={{ maxWidth: "280px", textAlign: "right" }}></td>
                                <td></td>
                                <td style={{ minWidth: "120px", textAlign: "right" }}>{"€ " + parseFloat(sessionStorage.getItem("totSpeTra1")).toFixed(2)}</td>
                            </tr>*/}
                            </table>
                            {global.aziendaID == 1 ? (
                              <div
                                className="your-order-bottom"
                                id="spedizioneGLS"
                                style={{
                                  border: "1px gray dotted",
                                  padding: "3px",
                                  backgroundColor: "#d3d3d3",
                                }}
                              >
                                <ul>
                                  <li
                                    className="your-order-shipping"
                                    style={{ fontSize: "13px" }}
                                  >
                                    Costi di Spedizione
                                  </li>
                                  <li
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "right",
                                    }}
                                  >
                                    Italia: 1° collo € 12,90 + 2 ° collo € 6,00{" "}
                                    <br /> + € 4,00 i successivi + € 2.00 spese
                                    contrassegno
                                    {/*<br />
                                  Campania: 1° collo € 8,00 + € 2,00 successivi*/}
                                  </li>
                                </ul>
                                <ul style={{ display: "none" }}>
                                  <li
                                    className="your-order-shipping"
                                    style={{ fontSize: "13px" }}
                                  >
                                    Costi di Spedizione BRT
                                  </li>
                                  <li
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "right",
                                    }}
                                  >
                                    Italia: 1° collo € 12.00 + 2° collo € 6.00{" "}
                                    <br /> € 4,00 successivi
                                  </li>
                                </ul>
                              </div>
                            ) : null}

                            <div
                              className="additional-info-wrap"
                              style={{ borderTop: "1px solid lightgray" }}
                            >
                              <label style={{ width: "30%" }} for="modGreen">
                                Modalità di spedizione
                              </label>
                              <select
                                style={{
                                  width: "70%",
                                  border: "1px solid gray",
                                }}
                                id="modGreen"
                                onChange={(e) => {
                                  document.getElementById(
                                    "dataRitiro"
                                  ).style.display = "none";
                                  if (
                                    e.target.value == 31 ||
                                    e.target.value == 33
                                  )
                                    document.getElementById(
                                      "detSpeGre"
                                    ).style.display = "block";
                                  else
                                    document.getElementById(
                                      "detSpeGre"
                                    ).style.display = "none";
                                  if (e.target.value == 34) {
                                    //setShowDialogSpedizioni2maggio(true)
                                    document.getElementById(
                                      "dataRitiro"
                                    ).style.display = "block";
                                    setDateCaricate(false);
                                    calcolaDate();
                                  }
                                  //if (e.target.value != 34) setShowDialogSpedizioniControlloCAP(true)
                                }}
                              >
                                <option value="">Seleziona una risposta</option>
                                {spedizioni.map((item) => (
                                  <option value={item.id}>{item.Des}</option>
                                ))}
                              </select>
                              <p
                                id="detSpeGre"
                                style={{
                                  display: "none",
                                  backgroundColor: "red",
                                  color: "white",
                                  padding: "3px",
                                }}
                              >
                                <strong>
                                  Attenzione! Si consiglia di selezionare questa
                                  modalità <u>SOLO</u> se ha un contratto con il
                                  corriere.
                                </strong>
                              </p>

                              <div
                                id="dataRitiro"
                                className="col-span-1"
                                style={{ display: "none", marginTop: "10px" }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  localeText={itIT}
                                  locale={it}
                                  adapterLocale={it}
                                >
                                  <DatePicker
                                    key={new Date()}
                                    disabled={!dateCaricate}
                                    onError={(newError) => setError(newError)}
                                    onBeforeInput={(e) => {
                                      e.preventDefault();
                                    }}
                                    label="Data ritiro"
                                    fullWidth
                                    value={dataRitiro}
                                    onChange={(value) => setDataRitiro(value)}
                                    format={"dd/MM/yyyy"}
                                    disablePast
                                    disableHighlightToday
                                    shouldDisableDate={(date) =>
                                      isDisabled(date)
                                    }
                                    slotProps={{
                                      layout: {
                                        sx: {
                                          ".Mui-disabled": {
                                            backgroundColor: "red",
                                            color: "white !important",
                                            borderRadius: "50%",
                                          },
                                          ".css-1vlm3gk-MuiFormControl-root-MuiTextField-root":
                                            {
                                              width: "100%",
                                            },
                                        },
                                      },
                                    }}
                                    sx={{
                                      ".MuiTextField-root": {
                                        width: "100%",
                                      },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          readOnly: true,
                                        }}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        error={error || errorMessage}
                                        fullWidth
                                        required
                                        disabled
                                        style={{ width: "100%" }}
                                        onKeyDown={(e) => e.preventDefault()}
                                        //placeholder = "gg/mm/aaaa"
                                      />
                                    )}
                                    variant="outlined"
                                    id="dataRitiro"
                                    //placeholder = "gg/mm/aaaa"
                                  />
                                </LocalizationProvider>
                                {!dateCaricate && <CircularProgress />}
                                {errorMessage && (
                                  <p style={{ color: "red" }}>{errorMessage}</p>
                                )}
                              </div>
                              {global.aziendaID == 2 && (
                                <div
                                  className="additional-info-wrap"
                                  style={{
                                    display: "flex",
                                    marginTop: "5%",
                                    borderTop: "1px solid lightgray",
                                  }}
                                >
                                  <label
                                    style={{ width: "30%" }}
                                    for="modGreen"
                                  >
                                    Modalità di pagamento
                                  </label>
                                  <Autocomplete
                                    className="data"
                                    id="country-select-demo-legale"
                                    options={pagamenti}
                                    defaultValue={pagamenti?.find(
                                      (pagamento) => pagamento.pagCli == 1
                                    )}
                                    autoHighlight
                                    onChange={(event, value) => {
                                      setPagamento(value);
                                    }}
                                    getOptionLabel={(option) => option.DesPag}
                                    style={{
                                      border: "none",
                                      marginTop: "10px",
                                      width: "70%",
                                    }}
                                    sx={{
                                      border: "1px solid green",
                                      borderRadius: 1,
                                    }}
                                    renderOption={(option) => (
                                      <React.Fragment>
                                        {option.DesPag}
                                      </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Modalità di pagamento"
                                        error={error}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password", // disable autocomplete and autofill
                                          style: { border: "none" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="additional-info"
                              style={{ marginTop: "20px" }}
                            >
                              <textarea
                                style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                                placeholder="Annotazioni sull'ordine, esempio annotazioni sulla spedizione"
                                id="messageGreen"
                                defaultValue={""}
                              />
                            </div>
                          </div>
                        )}
                        {(getTotYellow() > 0 || getTotPre() > 0) && (
                          <div
                            style={{
                              backgroundColor: "rgba(244, 255, 125,0.15)",
                              marginBottom: "30px",
                              padding: "10px",
                            }}
                          >
                            {getTotYellow() > 0 && (
                              <table style={{ width: "100%" }}>
                                <tr
                                  style={{
                                    fontSize: "18px",
                                    borderBottom: "0.5px solid gray",
                                  }}
                                >
                                  <td
                                    style={{
                                      minWidth: "130px",
                                      maxWidth: "280px",
                                    }}
                                  >
                                    Art. in arrivo
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "70px",
                                      textAlign: "right",
                                    }}
                                  >
                                    In arr.
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "70px",
                                      textAlign: "right",
                                    }}
                                  >
                                    Prezzo
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "70px",
                                      textAlign: "right",
                                    }}
                                  >
                                    Totale
                                  </td>
                                </tr>
                                {cartItems.map((cartItem, key) => {
                                  var popup =
                                    cartItem.pricesco != cartItem.priceNoSco
                                      ? cartItem.priceNoSco + " - "
                                      : "";
                                  popup +=
                                    cartItem.sco1 != 0
                                      ? cartItem.sco1 + "% "
                                      : "";
                                  popup +=
                                    cartItem.sco2 != 0
                                      ? cartItem.sco2 + "% "
                                      : "";
                                  popup +=
                                    cartItem.sco3 != 0
                                      ? cartItem.sco3 + "% "
                                      : "";
                                  popup +=
                                    cartItem.sco4 != 0 ? cartItem.sco4 : "%";
                                  popup = popup.substring(0, popup.length - 1);
                                  if (cartItem.tipoSconto == 1)
                                    popup = cartItem.priceNoSco; //se prezzo fisso
                                  return (
                                    cartItem.qtyArr != 0 && (
                                      <tr
                                        style={{
                                          borderBottom: "1px solid lightgray",
                                        }}
                                      >
                                        <td
                                          style={{
                                            minWidth: "130px",
                                            maxWidth: "280px",
                                          }}
                                        >
                                          {cartItem.name}
                                          <br />
                                          <span style={{ fontSize: "10px" }}>
                                            {cartItem.selectedProductColor} /{" "}
                                            {cartItem.selectedProductSize}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            maxWidth: "280px",
                                            textAlign: "right",
                                          }}
                                        >
                                          {cartItem.qtyArr}
                                        </td>
                                        <td
                                          title={popup}
                                          style={{
                                            maxWidth: "120px",
                                            textAlign: "right",
                                          }}
                                        >
                                          {"€ " +
                                            calcolaPrezzo(
                                              cartItem.priceNoSco,
                                              cartItem.pricesco,
                                              undefined,
                                              cartItem.id,
                                              cartItem
                                            ).toFixed(2)}
                                        </td>
                                        <td
                                          style={{
                                            minWidth: "120px",
                                            textAlign: "right",
                                          }}
                                        >
                                          {"€ " +
                                            (
                                              calcolaPrezzo(
                                                cartItem.priceNoSco,
                                                cartItem.pricesco,
                                                undefined,
                                                cartItem.id,
                                                cartItem
                                              ).toFixed(2) * cartItem.qtyArr
                                            ).toFixed(2)}
                                        </td>
                                      </tr>
                                    )
                                  );
                                })}
                                <tr
                                  style={{
                                    borderTop: "1px solid gray",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <td style={{ maxWidth: "280px" }}>TOTALE</td>
                                  <td
                                    style={{
                                      maxWidth: "280px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {getTotYellow()}
                                  </td>
                                  <td></td>
                                  <td
                                    style={{
                                      minWidth: "120px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {"€ " + getTotPriceYellow().toFixed(2)}
                                  </td>
                                </tr>
                                {/*<tr style={{ borderTop: "1px solid gray", fontWeight: "bold" }} id="speTraYellow">
                                <td style={{ maxWidth: "280px" }}>Spedizione</td>
                                <td style={{ maxWidth: "280px", textAlign: "right" }}></td>
                                <td></td>
                                <td style={{ minWidth: "120px", textAlign: "right" }}>{"€ " + parseFloat(sessionStorage.getItem("totSpeTra2")).toFixed(2)}</td>
                            </tr>*/}
                              </table>
                            )}
                            {getTotPre() > 0 && (
                              <div
                                style={{
                                  backgroundColor: "rgba(255, 255, 255,0.75)",
                                  marginTop: "20px",
                                  marginLeft: "-10px",
                                  width: "105%",
                                  padding: "10px",
                                }}
                              >
                                <table style={{ width: "100%" }}>
                                  <tr
                                    style={{
                                      fontSize: "18px",
                                      borderBottom: "0.5px solid gray",
                                    }}
                                  >
                                    <td
                                      style={{
                                        minWidth: "70px",
                                        maxWidth: "280px",
                                      }}
                                    >
                                      Art. da prenotare
                                    </td>
                                    <td
                                      style={{
                                        minWidth: "70px",
                                        textAlign: "right",
                                      }}
                                    >
                                      Pren.
                                    </td>
                                    <td
                                      style={{
                                        minWidth: "70px",
                                        textAlign: "right",
                                      }}
                                    >
                                      Prezzo
                                    </td>
                                    <td
                                      style={{
                                        minWidth: "70px",
                                        textAlign: "right",
                                      }}
                                    >
                                      Totale
                                    </td>
                                  </tr>
                                  {cartItems.map((cartItem, key) => {
                                    var popup =
                                      cartItem.pricesco != cartItem.priceNoSco
                                        ? cartItem.priceNoSco + " - "
                                        : "";
                                    popup +=
                                      cartItem.sco1 != 0
                                        ? cartItem.sco1 + "% "
                                        : "";
                                    popup +=
                                      cartItem.sco2 != 0
                                        ? cartItem.sco2 + "% "
                                        : "";
                                    popup +=
                                      cartItem.sco3 != 0
                                        ? cartItem.sco3 + "% "
                                        : "";
                                    popup +=
                                      cartItem.sco4 != 0 ? cartItem.sco4 : "%";
                                    popup = popup.substring(
                                      0,
                                      popup.length - 1
                                    );
                                    if (cartItem.tipoSconto == 1)
                                      popup = cartItem.priceNoSco; //se prezzo fisso
                                    return (
                                      cartItem.qtyPre != 0 && (
                                        <tr
                                          style={{
                                            borderBottom: "1px solid lightgray",
                                          }}
                                        >
                                          <td style={{ maxWidth: "280px" }}>
                                            {cartItem.name}
                                            <br />
                                            <span style={{ fontSize: "10px" }}>
                                              {cartItem.selectedProductColor} /{" "}
                                              {cartItem.selectedProductSize}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              maxWidth: "280px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {cartItem.qtyPre}
                                          </td>
                                          <td
                                            title={popup}
                                            style={{
                                              minWidth: "70px",
                                              maxWidth: "120px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {"€ " +
                                              calcolaPrezzo(
                                                cartItem.priceNoSco,
                                                cartItem.pricesco,
                                                undefined,
                                                cartItem.id,
                                                cartItem
                                              ).toFixed(2)}
                                          </td>
                                          <td
                                            style={{
                                              minWidth: "120px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {"€ " +
                                              (
                                                calcolaPrezzo(
                                                  cartItem.priceNoSco,
                                                  cartItem.pricesco,
                                                  undefined,
                                                  cartItem.id,
                                                  cartItem
                                                ).toFixed(2) * cartItem.qtyPre
                                              ).toFixed(2)}
                                          </td>
                                        </tr>
                                      )
                                    );
                                  })}
                                  <tr
                                    style={{
                                      borderTop: "1px solid gray",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <td style={{ maxWidth: "280px" }}>
                                      TOTALE
                                    </td>
                                    <td
                                      style={{
                                        maxWidth: "280px",
                                        textAlign: "right",
                                      }}
                                    >
                                      {getTotPre()}
                                    </td>
                                    <td></td>
                                    <td
                                      style={{
                                        minWidth: "120px",
                                        textAlign: "right",
                                      }}
                                    >
                                      {"€ " + getTotPricePre().toFixed(2)}
                                    </td>
                                  </tr>
                                  {/*<tr style={{ borderTop: "1px solid gray", fontWeight: "bold" }} id="speTraYellow">
                                <td style={{ maxWidth: "280px" }}>Spedizione</td>
                                <td style={{ maxWidth: "280px", textAlign: "right" }}></td>
                                <td></td>
                                <td style={{ minWidth: "120px", textAlign: "right" }}>{"€ " + parseFloat(sessionStorage.getItem("totSpeTra2")).toFixed(2)}</td>
                            </tr>*/}
                                </table>
                                {/*<div style={{ marginTop: "20px" }}>
                              <label style={{ width: "30%" }} for="attendiInvio">Voglio ricevere</label>
                              {getTotGreen() > 0 && <select style={{ width: "70%", border: "1px solid gray" }} id="attendiInvio" onChange={(e) => {
                                if(e.currentTarget.value == "0"){
                                  document.getElementById("yellowContainer").style.display="none"
                                  setSpeTra(parseFloat(TotSpeSpe1) + parseFloat(TotSpeSpe2))
                                }
                                if(e.currentTarget.value == "0" || e.currentTarget.value == "2"){
                                  //document.getElementById("speTraYellow").style.display="none"
                                  setSpeTra(parseFloat(TotSpeSpe1))

                                } 
                                else{
                                  document.getElementById("yellowContainer").style.display="block"
                                  //document.getElementById("speTraYellow").style.display="table-row"
                                  setSpeTra(parseFloat(TotSpeSpe1) + parseFloat(TotSpeSpe2))
                                }
                              } }>
                                <option value="">Seleziona una risposta</option>
                                <option value="0">Tutto in un'unica soluzione</option> 
                                <option value="1">Il disponibile ora ed il restante all'arrivo</option>
                                <option value="2">Il disponibile ed il restante con il prossimo ordine</option>
                              </select>
                              {getTotGreen() <= 0 && <select style={{ width: "70%", border: "1px solid gray" }} id="attendiInvio" onChange={(e) => {
                                if(e.currentTarget.value == "1"){
                                  //document.getElementById("speTraYellow").style.display="table-row"
                                  setSpeTra(parseFloat(TotSpeSpe2))
                                }
                                if(e.currentTarget.value == "2"){
                                  //document.getElementById("speTraYellow").style.display="none"
                                  setSpeTra(parseFloat(0))

                                } 
                               
                              } }>
                                <option value="">Seleziona una risposta</option>
                                <option value="1">Gli articoli all'arrivo</option>
                                <option value="2">Gli articoli nel prossimo ordine</option>
                              </select>}
                            </div>
                            <div className="additional-info-wrap" id="yellowContainer">
                              <label style={{ width: "30%" }} for="modYellow">Modalità di spedizione</label>
                              <select style={{ width: "70%", border: "1px solid gray" }} id="modYellow">
                              <option value="">Seleziona una risposta</option>
                                {spedizioni.map((item) => 
                                <option value={item.id} >{item.Des}</option>
                                )}
                              </select>
                              <div className="additional-info">
                                <textarea
                                  style={{backgroundColor: 'rgba(0, 0, 0, 0)'}}
                                  placeholder="Annotazioni sull'ordine, esempio annotazioni sulla spedizione"
                                  id="messageYellow"
                                  defaultValue={""}
                                />
                              </div>
                                </div>*/}
                              </div>
                            )}
                            <div
                              className="your-order-bottom"
                              id="spedizioneGLS"
                              style={{
                                border: "1px gray dotted",
                                padding: "3px",
                                backgroundColor: "#d3d3d3",
                              }}
                            >
                              <ul>
                                <li
                                  className="your-order-shipping"
                                  style={{ fontSize: "13px" }}
                                >
                                  Costi di Spedizione
                                </li>
                                <li
                                  style={{
                                    fontSize: "12px",
                                    textAlign: "right",
                                  }}
                                >
                                  Italia: 1° collo € 12,90 + 2 ° collo € 6,00{" "}
                                  <br /> + € 4,00 i successivi + € 2.00 spese
                                  contrassegno
                                  {/*<br />
                                  Campania: 1° collo € 8,00 + € 2,00 successivi*/}
                                </li>
                              </ul>
                              <ul style={{ display: "none" }}>
                                <li
                                  className="your-order-shipping"
                                  style={{ fontSize: "13px" }}
                                >
                                  Costi di Spedizione BRT
                                </li>
                                <li
                                  style={{
                                    fontSize: "12px",
                                    textAlign: "right",
                                  }}
                                >
                                  Italia: 1° collo € 12.00 + 2° collo € 6.00{" "}
                                  <br /> € 4,00 successivi
                                </li>
                              </ul>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                              <p
                                id="avviso"
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  padding: "3px",
                                }}
                              >
                                <strong>
                                  ATTENZIONE! STAI METTENDO IN PRENOTAZIONE
                                  MERCE ATTUALMENTE NON DISPONIBILE IN
                                  MAGAZZINO.
                                </strong>
                              </p>
                              <label
                                style={{ width: "30%" }}
                                for="attendiInvio"
                              >
                                Voglio ricevere
                              </label>
                              {getTotGreen() > 0 && (
                                <select
                                  style={{
                                    width: "70%",
                                    border: "1px solid gray",
                                  }}
                                  id="attendiInvio"
                                  onChange={(e) => {
                                    if (e.currentTarget.value == "0") {
                                      document.getElementById(
                                        "yellowContainer"
                                      ).style.display = "none";
                                      setSpeTra(
                                        parseFloat(TotSpeSpe1) +
                                          parseFloat(TotSpeSpe2)
                                      );
                                      document.getElementById(
                                        "dataRitiro"
                                      ).style.display = "none";
                                    }
                                    if (
                                      e.currentTarget.value == "0" ||
                                      e.currentTarget.value == "2"
                                    ) {
                                      //document.getElementById("speTraYellow").style.display="none"
                                      setSpeTra(parseFloat(TotSpeSpe1));
                                    } else {
                                      document.getElementById(
                                        "yellowContainer"
                                      ).style.display = "block";
                                      //document.getElementById("speTraYellow").style.display="table-row"
                                      setSpeTra(
                                        parseFloat(TotSpeSpe1) +
                                          parseFloat(TotSpeSpe2)
                                      );
                                    }
                                    if (e.currentTarget.value == "0")
                                      document.getElementById(
                                        "dataRitiro"
                                      ).style.display = "none";
                                    else if (
                                      parseInt(
                                        document.getElementById("modGreen") &&
                                          document.getElementById("modGreen")
                                            .value != ""
                                          ? document.getElementById("modGreen")
                                              .value
                                          : 0
                                      ) == 34
                                    )
                                      document.getElementById(
                                        "dataRitiro"
                                      ).style.display = "block";
                                  }}
                                >
                                  <option value="">
                                    Seleziona una risposta
                                  </option>
                                  <option value="0">
                                    Tutto in un'unica soluzione
                                  </option>{" "}
                                  {/*sdoppiamento ordini 15/12/2021*/}
                                  <option value="1">
                                    Il disponibile ora ed il restante all'arrivo
                                  </option>
                                  <option value="2" style={{ display: "none" }}>
                                    Il disponibile ed il restante con il
                                    prossimo ordine
                                  </option>
                                </select>
                              )}
                              <div></div>
                              {getTotGreen() <= 0 && (
                                <select
                                  style={{
                                    width: "70%",
                                    border: "1px solid gray",
                                  }}
                                  id="attendiInvio"
                                  onChange={(e) => {
                                    if (e.currentTarget.value == "1") {
                                      //document.getElementById("speTraYellow").style.display="table-row"
                                      setSpeTra(parseFloat(TotSpeSpe2));
                                    }
                                    if (e.currentTarget.value == "2") {
                                      //document.getElementById("speTraYellow").style.display="none"
                                      setSpeTra(parseFloat(0));
                                    }
                                  }}
                                >
                                  <option value="">
                                    Seleziona una risposta
                                  </option>
                                  <option value="1">
                                    Gli articoli all'arrivo
                                  </option>
                                  <option value="2">
                                    Gli articoli nel prossimo ordine
                                  </option>
                                </select>
                              )}
                            </div>
                            <div
                              className="additional-info-wrap"
                              id="yellowContainer"
                            >
                              <label style={{ width: "30%" }} for="modYellow">
                                Modalità di spedizione
                              </label>
                              <select
                                style={{
                                  width: "70%",
                                  border: "1px solid gray",
                                }}
                                id="modYellow"
                                onChange={(e) => {
                                  if (
                                    e.target.value == 31 ||
                                    e.target.value == 33
                                  )
                                    document.getElementById(
                                      "detSpeYel"
                                    ).style.display = "block";
                                  else
                                    document.getElementById(
                                      "detSpeYel"
                                    ).style.display = "none";
                                }}
                              >
                                <option value="">Seleziona una risposta</option>
                                {spedizioni.map((item) => (
                                  <option value={item.id}>{item.Des}</option>
                                ))}
                              </select>

                              <p
                                id="detSpeYel"
                                style={{
                                  display: "none",
                                  backgroundColor: "red",
                                  color: "white",
                                  padding: "3px",
                                }}
                              >
                                <strong>
                                  Attenzione! Si consiglia di selezionare questa
                                  modalità <u>SOLO</u> se ha un contratto con il
                                  corriere.
                                </strong>
                              </p>
                              <div
                                className="additional-info"
                                style={{ marginTop: "20px" }}
                              >
                                <textarea
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0)",
                                  }}
                                  placeholder="Annotazioni sull'ordine, esempio annotazioni sulla spedizione"
                                  id="messageYellow"
                                  defaultValue={""}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {getTotRed() > 0 && (
                          <div
                            style={{
                              backgroundColor: "rgba(255, 59, 59,0.15)",
                              marginBottom: "30px",
                              padding: "10px",
                            }}
                          >
                            <table>
                              <tr
                                style={{
                                  fontSize: "18px",
                                  borderBottom: "0.5px solid gray",
                                }}
                              >
                                <td>Articoli non disponibili</td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    textAlign: "right",
                                  }}
                                >
                                  Non disp.
                                </td>
                                <td
                                  style={{
                                    minWidth: "70px",
                                    textAlign: "right",
                                  }}
                                >
                                  Prezzo
                                </td>
                                <td
                                  style={{
                                    minWidth: "70px",
                                    textAlign: "right",
                                  }}
                                >
                                  Totale
                                </td>
                              </tr>
                              {cartItems.map((cartItem, key) => {
                                var popup =
                                  cartItem.pricesco != cartItem.priceNoSco
                                    ? cartItem.priceNoSco + " - "
                                    : "";
                                popup +=
                                  cartItem.sco1 != 0
                                    ? cartItem.sco1 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco2 != 0
                                    ? cartItem.sco2 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco3 != 0
                                    ? cartItem.sco3 + "% "
                                    : "";
                                popup +=
                                  cartItem.sco4 != 0 ? cartItem.sco4 : "%";
                                popup = popup.substring(0, popup.length - 1);
                                if (cartItem.tipoSconto == 1)
                                  popup = cartItem.priceNoSco; //se prezzo fisso
                                return (
                                  cartItem.qtyNO != 0 && (
                                    <tr
                                      style={{
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      <td style={{ maxWidth: "280px" }}>
                                        {cartItem.name}
                                        <br />
                                        <span style={{ fontSize: "10px" }}>
                                          {cartItem.selectedProductColor} /{" "}
                                          {cartItem.selectedProductSize}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          maxWidth: "280px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {cartItem.qtyNO}
                                      </td>
                                      <td
                                        title={popup}
                                        style={{
                                          maxWidth: "120px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {"€ " +
                                          (
                                            cartItem.priceNoSco *
                                            (1 - personal.S1 / 100) *
                                            (1 - personal.S2 / 100)
                                          ).toFixed(2)}
                                      </td>
                                      <td
                                        style={{
                                          minWidth: "120px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {"€ " +
                                          (
                                            (
                                              cartItem.priceNoSco *
                                              (1 - personal.S1 / 100) *
                                              (1 - personal.S2 / 100)
                                            ).toFixed(2) * cartItem.qtyNO
                                          ).toFixed(2)}
                                      </td>
                                    </tr>
                                  )
                                );
                              })}
                              <tr
                                style={{
                                  borderTop: "1px solid gray",
                                  fontWeight: "bold",
                                }}
                              >
                                <td style={{ maxWidth: "280px" }}>TOTALE</td>
                                <td
                                  style={{
                                    maxWidth: "280px",
                                    textAlign: "right",
                                  }}
                                >
                                  {getTotRed()}
                                </td>
                                <td></td>
                                <td
                                  style={{
                                    minWidth: "120px",
                                    textAlign: "right",
                                  }}
                                >
                                  {"€ " + getTotPriceRed().toFixed(2)}
                                </td>
                              </tr>
                            </table>
                            <div style={{ marginTop: "20px", display: "none" }}>
                              <input
                                style={{ width: "10%", height: "15px" }}
                                type="checkbox"
                                id="sollecito"
                                name="sollecito"
                                onChange={(e) => {
                                  if (e.currentTarget.checked) {
                                    document.getElementById(
                                      "messageRed"
                                    ).style.display = "inherit";
                                  } else {
                                    document.getElementById(
                                      "messageRed"
                                    ).style.display = "none";
                                  }
                                }}
                              />
                              <label style={{ width: "80%" }} for="scales">
                                Sollecita gli articoli non disponibili
                              </label>
                            </div>
                            <div className="additional-info-wrap">
                              <div className="additional-info">
                                <textarea
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0)",
                                    display: "none",
                                  }}
                                  placeholder="Annotazioni sull'ordine, esempio annotazioni sulla spedizione"
                                  id="messageRed"
                                  defaultValue={""}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {/*<div className="your-order-top">
                          <ul>
                            <li>Prodotto</li>
                            <li>Disponibilità</li>
                            <li>Totale</li>
                          </ul>
                        </div>
                        <div className="your-order-middle">
                          <ul>
                            {cartItems.map((cartItem, key) => {
                              const discountedPrice = getDiscountPrice(
                                cartItem.price,
                                cartItem.discount
                              );
                              const finalProductPrice = cartItem.price ? (
                                cartItem.price * currency.currencyRate
                              ).toFixed(2) : 0;
                              const finalDiscountedPrice = (
                                discountedPrice * currency.currencyRate
                              ).toFixed(2);

                              discountedPrice != null
                                ? (cartTotalPrice +=
                                    finalDiscountedPrice * cartItem.quantity)
                                : (cartTotalPrice +=
                                    finalProductPrice * cartItem.quantity);
                              return (
                                <li key={key}>
                                  <span className="order-middle-left">
                                    {cartItem.name} X {cartItem.quantity}
                                  </span>{" "}
                                  <span className="order-price">
                                    {discountedPrice !== null
                                      ? currency.currencySymbol +
                                        (
                                          finalDiscountedPrice *
                                          cartItem.quantity
                                        ).toFixed(2)
                                      : currency.currencySymbol +
                                        (
                                          finalProductPrice * cartItem.quantity
                                        ).toFixed(2)}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                          </div>*/}
                        {/*parseInt(document.getElementById("modGreen") && document.getElementById("modGreen").value != '' ? document.getElementById("modGreen").value : 0) == 32 && <div className="your-order-bottom" id="spedizioneGLS">
                          <ul>
                            <li className="your-order-shipping">Costi di Spedizione</li>
                            <li style={{ fontSize: "12px", textAlign: "right" }}>Italia: 1° collo € 10,00 + € 5,00 successivi
                              <br />
                              Campania: 1° collo € 6,50 + € 1,50 successivi</li>
                          </ul>
                        </div>*/}
                        {/*parseInt(document.getElementById("modGreen") && document.getElementById("modGreen").value != '' ? document.getElementById("modGreen").value : 0) == 30 && <div className="your-order-bottom" id="spedizioneBRT">
                          <ul>
                            <li className="your-order-shipping">Costi di Spedizione</li>
                            <li style={{ fontSize: "12px", textAlign: "right" }}>Italia: 1° collo € 10,00 + € 7,00 successivi </li>
                          </ul>
                      </div>*/}
                        {global.aziendaID == 1 ? (
                          <div>
                            <input
                              type={"checkbox"}
                              style={{ width: "auto", height: "auto" }}
                              id="flgWebPos"
                            />
                            &nbsp;Paga con{" "}
                            <img
                              src="https://webpos.sinergia.bcc.it/images/wp_business/webpos-business-logo.png"
                              style={{ width: "30%" }}
                            />
                            <i
                              className="fa fa-info-circle"
                              title="All'emissione della fattura, verrà inviato
un link per effettuare il pagamento
tramite carta di credito o debito."
                            />
                          </div>
                        ) : null}
                        <div
                          className="your-order-total"
                          style={{ textAlign: "right" }}
                        >
                          <ul>
                            <li className="order-total">Totale Carrello</li>
                            <li>
                              {"€ " +
                                (
                                  getTotPriceGreen() +
                                  getTotPriceYellow() +
                                  getTotPriceRed() +
                                  getTotPricePre()
                                ).toFixed(2)}
                              <br />
                              {(userData.user.user.ParIva ||
                                userData.user.user.ParIva != "" ||
                                userData.user.user.ParIva != null) &&
                              global.aziendaID == 1 ? (
                                <span style={{ fontSize: "10px" }}>
                                  Iva esclusa
                                </span>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="payment-method"></div>
                    </div>
                    <div className="place-order mt-25">
                      {!isCaricamento && (
                        <button
                          className="btn-hover"
                          onClick={() => inviaOrdine()}
                        >
                          Invia l'Ordine
                        </button>
                      )}
                      {isCaricamento && (
                        <Article key={"bars"}>
                          <ReactLoading type={"bars"} color="#2E98F0" />
                        </Article>
                      )}
                      {errorMessage && (
                        <p style={{ color: "red" }}>{errorMessage}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              show && (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="item-empty-area text-center">
                      <div className="item-empty-area__icon mb-30">
                        <i className="pe-7s-cash"></i>
                      </div>
                      <div className="item-empty-area__text">
                        Ordine inviato correttamente <br />{" "}
                        <Link
                          to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                        >
                          Acquista ora
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Checkout.propTypes = {
  cartItems: PropTypes.array,
  currency: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    cartItemsAll: state.cartData,
    currency: state.currencyData,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adjustCartForCheckOut: (item) => {
      dispatch(adjustCartForCheckOut(item));
    },
    removeAllFromCart: (addToast) => {
      dispatch(removeAllFromCart(addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
